

import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class AttributeValueService extends BaseService {
	constructor() {
		super('/AttributeValue');
	}


	public getAllByFilter(filter: AttributeValueFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class AttributeValueFilter extends BaseFilter {
	constructor(idPerson?: number | null, idTenant?: number | null) {
		super();
		this._idTenant = idTenant;
		this._idPerson = idPerson;
		
	}

	private _idTenant?: number | null;
	private _idPerson?: number | null;
	

	public getAllParams(): {} {
	
		let data = Object.assign({},
			(this._idPerson != null ? { IdPerson: this._idPerson } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {})
		);
	
		return data;
	};
}